import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { name } from './symbols'
import { BrowserWindow, BrowserWindowSymbol, EditorFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { IStylableHandlers, ViewerManagerStylableApiEditorConfig } from './types'
import { handleCssTransitions } from './stylableApiFunctions'

const stylableFactory = (
	{ stylableInstance, compIdToStyleIds }: ViewerManagerStylableApiEditorConfig,
	browserWindow: NonNullable<BrowserWindow>
): IModelUpdatesHandlersImplementor<IStylableHandlers> => {
	return {
		featureName: name,
		handlers: {
			updateStylableTransition: ({ editorMode }) => {
				if (compIdToStyleIds) {
					Object.keys(compIdToStyleIds).forEach((compId) => {
						compIdToStyleIds[compId].forEach((styleId) => {
							handleCssTransitions(stylableInstance, styleId, compId, editorMode, browserWindow)
						})
					})
				}
			},
		},
	}
}

export const StylableHandlers = withDependencies(
	[named(EditorFeatureConfigSymbol, name), BrowserWindowSymbol],
	stylableFactory
)
